module.exports = __webpack_public_path__ + "media/images/login/login_t3_l-abd45c04513263bde5e991816d1bfaf1.gif";